import { useState } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useAnalytics from "hooks/useAnalytics";
import useTypedContext from "hooks/useTypedContext";
import { TrackAnalyticsEventProperties } from "shared/Analytics";

import { Certificate } from "../useUserGuideCertificates";
import { CERTIFICATE_DOWNLOAD_EVENT_NAME } from "../analytics";
import { downloadCertificatePng } from "./downloadCertificatePng";

const useUserGuideDownloadCertificate = (
  certificate: Certificate | undefined,
  analyticsProps?: TrackAnalyticsEventProperties
) => {
  const { reportError } = useTypedContext(FlashContext);
  const trackSegmentEvent = useAnalytics();
  const [isDownloading, setIsDownloading] = useState(false);

  const download = async () => {
    if (!certificate || isDownloading) return;

    trackSegmentEvent(CERTIFICATE_DOWNLOAD_EVENT_NAME, analyticsProps);
    setIsDownloading(true);
    try {
      await downloadCertificatePng(certificate);
    } catch {
      reportError({ message: "Could not download the certificate. Please try again." });
    } finally {
      setIsDownloading(false);
    }
  };

  return { download, isDownloading };
};

export default useUserGuideDownloadCertificate;
